/**
 * Handles all logins
 */

import Logger from '../helpers/logger';

const log = new Logger();

export default ['$http', function LoginService($http) {
  /**
   * V1-specific login
   *
   * @param formData
   * @returns {*}
   */
  this.v1 = (formData) => {
    const data = {
      method: 'POST',
      data: `emailAddress=${encodeURIComponent(formData.emailAddress)}&password=${encodeURIComponent(formData.password)}`, //eslint-disable-line
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      url: process.env.TRIALS.V1_INFO_URL
    };

    log.debug({
      category: 'service.login',
      message: 'v1'
    });

    return $http(data);
  };

  /**
   * V2-specific login
   * We have to go through Auth0 with the username/password in
   * order to get the token_id used to login. Lame, but necessary.
   *
   * @param formData
   * @returns {*}
   */
  this.v2 = (formData) => {
    const data = {
      audience: process.env.AUTH0.AUDIENCE,
      client_id: process.env.AUTH0.CLIENT_ID,
      grant_type: 'http://auth0.com/oauth/grant-type/password-realm',
      password: formData.password,
      popup: false,
      realm: 'Username-Password-Authentication',
      scope: 'openid profile',
      username: formData.emailAddress
    };

    log.debug({
      category: 'service.login',
      message: 'v2'
    });

    return $http.post(process.env.AUTH0.LOGIN_URL, data);
  };
}];
